import { OutlinedInput, styled } from "@mui/material";

const StyledTextField = styled(OutlinedInput)(
  ({ showLabel = true, error = false, theme }) => {
    return {
      height: 44,
      background: showLabel ? "inherit" : "#ffffff",
      paddingRight: theme.spacing(1),
      "& input ": {
        padding: theme.spacing(1.25),
        fontSize: 16,
        fontWeight: 400,
        lineHeight: theme.spacing(3),
      },
    };
  }
);

export default StyledTextField;
